<template>
    <!--<div>-->
    <!--<div class="polygon-container">-->
    <!--<div class="polygon"></div>-->
    <div class="container-fluid layout-wrapper mb-0">
        <div class="row">
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="card header-report bg-gradient-pastel-yellow clickable">
                    <!--@click="redirectTo('depositreport')">-->

                    <div class="card-body">
                        <h5 class="text-right">مانده سپرده</h5>
                        <div class="loader" v-if="isLoading">Loading...</div>
                        <div v-else class="text-left">
                            <h5 class="text-white mb-0">
                                <strong>{{validatePrice(desposRemain)}}</strong>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="card header-report bg-gradient-pastel-yellow clickable">
                    <!--@click="redirectTo('loanreport')">-->
                    <div class="card-body">
                        <h5 class="text-right">مانده وام</h5>
                        <div class="loader" v-if="isLoading">Loading...</div>
                        <div v-else class="text-left">
                            <h5 class="text-white mb-0">
                                <strong>{{validatePrice(loanRemain)}}</strong>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="card header-report bg-gradient-pastel-red clickable"
                     @click="redirectTo('requestreport')">
                    <div class="card-body">
                        <h5 class="text-right">درخواست های وام</h5>
                        <div class="loader" v-if="isLoading">Loading...</div>
                        <div v-else class="statistic-container">
                            <div>
                                <h5 class="text-white mb-0">
                                    <strong>{{myRequests}}</strong>
                                </h5>
                                <!--<img src="/img/gold-medal.svg" class="img-fluid medal">-->
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="card header-report bg-gradient-pastel-green  ">
                    <div class="card-body">
                        <h5 class="text-right">درخواست های ضمانت</h5>
                        <div class="loader" v-if="isLoading">Loading...</div>
                        <div v-else class="statistic-container">
                            <div>
                                <h5 class="text-white mb-0">
                                    <strong>{{myGuaranty}}</strong>
                                </h5>
                                <!--<img src="/img/gold-medal.svg" class="img-fluid medal">-->
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="col-lg-3 col-md-6 mb-4">-->

        </div>

        <h4 class="text-primary">پیامهای کاربر</h4>
        <small class="text-primary">برای مشاهده متن کامل پیام بر روی آن کلیک کنید</small>
        <div class="row">
            <div class="col-12">
                <div class="card shadow bg-gradient-pastel-light">
                    <div class="table-responsive">
                        <div v-if="messages.length===0">
                            <h5 class="text-center mt-3">شما پیام جدیدی ندارید</h5>
                        </div>
                        <div class="table-responsive" v-else>
                            <table class="table table-hover table-transparent">
                                <thead>
                                <tr>
                                    <th class="text-center">تاریخ</th>
                                    <th class="text-center">پیام</th>
                                    <th class="text-center">تاریخ ارسال</th>
                                    <!--<th>وضعیت</th>-->

                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="it in messages">
                                    <td class="text-center">{{it.crprdate}}</td>
                                    <td><a class="clickable"
                                           @click="onViewMessageClicked(it.id)">{{it.message}}</a></td>
                                    <td class="text-center">{{it.prdate}}</td>
                                    <!--<td>{{it.showStatus}}</td>-->


                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--</div>-->
    <!--</div>-->
</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import * as $ from "jquery";
    import Moment from "moment-jalali";
    import EventBus from "../_framework/event-bus";

    export default {
        name: 'home',
        components: {},
        data() {
            return {
                isLoading: false,
                model: {
                    myWallet: 0,
                    // مسابقات شرکت کرده
                    meInMatchRunning: 0,
                    meInMatchEnded: 0,
                    meInMatchFuture: 0,
                    // مسابقات برگزار کرده
                    myMatchRunning: 0,
                    myMatchEnded: 0,
                    myMatchFuture: 0,
                    // قهرمانی های من
                    goldMedals: 0,
                    silverMedals: 0,
                    myMatchesDetails: {},
                    meInMatchDetail: {}
                },
                lastMaches: [],

                desposRemain: 0,
                loanRemain: 0,
                messages: [],
                myGuaranty: 0,
                myRequests: 0,

            }
        },
        mounted() {
            // this.getDashboardData();
            // let t = localStorage.getItem('theme');
            // if (t === 'dark') {
            //
            //     EventBus.$emit('theme', 'dark');
            //     localStorage.setItem("theme", 'dark');
            // } else if (t === 'light') {
            //     EventBus.$emit('theme', 'light');
            //     localStorage.setItem("theme", 'light');
            // } else {
            //     EventBus.$emit('theme', 'light');
            //     localStorage.setItem("theme", 'light');
            // }
            this.getDashboardData();
            // $("body").addClass("polygon");

        },
        methods: {
            getDashboardData() {
                this.isLoading = true;
                new BaseService("Dashboard").getList().then(response => {
                    // console.log(response.data);
                    this.isLoading = false;
                    // this.myWallet = response.data.myWallet;
                    // this.likes = response.data.likes;
                    this.messages = response.data.data.myMessages;
                    for (let it of this.messages) {
                        it.crprdate = Moment(it.createdOn, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');
                        it.prdate = Moment(it.messageDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');
                        // switch(it.status){
                        //     case 0:
                        //         break;
                        //     case 1:
                        //         break;
                        //     case 2:
                        // }
                        // it.statusText
                        // it.prdate2 = Moment(it.messageDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')
                    }

                    this.myRequests = response.data.data.myRequests;
                    this.myGuaranty = response.data.data.myGuaranty;
                    this.desposRemain = response.data.data.desposRemain;
                    this.loanRemain = response.data.data.loanRemain;


                    // setTimeout(() => {
                    // }, 2000)
                    // this.model = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                // new BaseService("ReportMainMatches", "/GetMatchesForDashboard").getList().then(response => {
                //     console.log(response.data);
                //     this.lastMaches = response.data.data;
                // }).catch(error => {
                //     Utils.handleErrorWithNotification(error.data, this.$noty);
            },
            onViewMessageClicked(id) {

                this.$router.push({
                    name: 'messages',
                });
            },
            // validateDate(date) {
            //     return Moment(date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY')
            // },
            // onRowClicked(id){
            //     this.$router.push({
            //         name: 'competitionsList',
            //         params: {
            //             id: id
            //         }
            //     });
            // },
        },
        // beforeRouteLeave(to, from, next) {
        //     $("body").removeClass("polygon");
        //     next();
        // },

    }
</script>

<style lang="scss" scoped>
    .transform-layout {
        transform: translateY(70px);
    }

    .bg-gradient-pastel-yellow {
        /*higher saturation color*/
        /*background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%);*/
        background-color: #e79087;
        background-image: linear-gradient(315deg, #e79087 0%, #fcd181 74%);
    }

    .bg-gradient-pastel-red {
        /*higher saturation color*/
        /*background-image: linear-gradient(to right, #ff758c 0%, #ff7eb3 100%);*/
        background-color: #f9d1b7;
        background-image: linear-gradient(315deg, #f9d1b7 0%, #f894a4 74%);

    }

    .bg-gradient-pastel-green {
        /*higher saturation color*/
        /*background-image: linear-gradient(to right, #43e97b 0%, #38f9d7 100%);*/
        background-color: #70b2d9;
        background-image: linear-gradient(315deg, #70b2d9 0%, #39e5b6 74%);
    }

    .bg-gradient-pastel-cyan {
        /*higher saturation color*/
        /*background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);*/
        background-color: #b1ade2;
        background-image: linear-gradient(315deg, #b1ade2 0%, #7ddff8 74%);
    }

    .bg-gradient-pastel-purple {
        background-color: #f9c5d1;
        background-image: linear-gradient(315deg, #f9c5d1 0%, #9795ef 74%);
    }

    .bg-gradient-pastel-orange {
        background-color: #ffac81;
        background-image: linear-gradient(315deg, #ffac81 0%, #ff928b 74%);
    }

    .bg-gradient-pastel-light {
        background-color: #d9e4f5;
        background-image: linear-gradient(315deg, #d9e4f5 0%, #f5e3e6 74%);
    }

    .table-transparent {
        margin-top: 1rem;
    }

    .table-transparent th {
        background-color: transparent;
        border-color: #d2d4d7 !important;
        border-top: none !important;
        color: #8898aa;
    }

    .table-transparent td {
        border-color: #d2d4d7;
        color: #525f7f;
    }

    .dashed-create-container {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px dashed #e5e5e5;
        color: #e5e5e5;
        border-radius: 0.5rem;
        margin: 0 auto;
        transition: all 0.3s;
    }

    .dashed-create-container:hover {
        color: #ffffff;
        border-color: #ffffff;
        cursor: pointer;
    }

    .card.header-report {
        border: none;
        box-shadow: 0 15px 35px rgba(50, 50, 93, .2), 0 5px 15px rgba(0, 0, 0, .1) !important;
        color: white;
    }

    .card.activity-history {
        min-height: 240px;
    }

    @media (min-width: 1599px) {
        .card.activity-history {
            min-height: 260px;
        }
    }

    @media (min-width: 1601px) {
        .card.activity-history {
            min-height: 315px;
        }
    }

    .card.activity-history .sport-icon {
        max-width: 150px;
    }

    .card.activity-history .card-body {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .card.header-report .statistic-container {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .card.header-report .statistic-container > div {
        display: flex;
        align-items: center;
    }

    .card.header-report img.medal {
        max-width: 25px;
    }

    .loader,
    .loader:after {
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
    }

    .loader {
        margin: 0 auto;
        font-size: 10px;
        position: relative;
        text-indent: -9999em;
        border-top: 0.25em solid rgba(255, 255, 255, 0.2);
        border-right: 0.25em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.25em solid rgba(255, 255, 255, 0.2);
        border-left: 0.25em solid #ffffff;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation: load8 1.1s infinite linear;
        animation: load8 1.1s infinite linear;
    }

    .loader.lg,
    .loader.lg:after {
        border-radius: 50%;
        width: 5em;
        height: 5em;
    }

    .loader.lg {
        margin: 60px auto;
        border-top: 0.5em solid rgba(255, 255, 255, 0.2);
        border-right: 0.5em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.5em solid rgba(255, 255, 255, 0.2);
        border-left: 0.5em solid #ffffff;
    }

    @-webkit-keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

</style>